export default "__VITE_ASSET__BTGIMAu6__"